import { OrganizationRaw } from "@/domain/Organization";
import { API_CLIENT } from "../config";
import { getAPIConfigs } from "../helpers";

import { Version } from "@/domain/Version";

const apiUrl = "/versions";

// バージョンを複製
export const postDuplicateVersion = async ({
  organizationId,
  versionId,
  title,
}: {
  organizationId: OrganizationRaw["org_id"];
  versionId: Version["id"];
  title: string;
}): Promise<{ new_version_id: string }> => {
  const { apiOrganizationIdParams } = getAPIConfigs(organizationId);
  const response = await API_CLIENT.post<{ new_version_id: string }>(
    `${apiUrl}/${versionId}/copy`,
    { title },
    {
      ...apiOrganizationIdParams,
    }
  );
  return response.data;
};

// バージョンを論理削除
export const postDeleteVersion = async ({
  organizationId,
  versionId,
}: {
  organizationId: OrganizationRaw["org_id"];
  versionId: Version["id"];
}): Promise<void> => {
  const { apiOrganizationIdParams } = getAPIConfigs(organizationId);
  await API_CLIENT.post(
    `${apiUrl}/${versionId}/delete`,
    {},
    {
      ...apiOrganizationIdParams,
    }
  );
};

// バージョンを物理削除
export const postRemoveVersion = async ({
  organizationId,
  versionId,
}: {
  organizationId: OrganizationRaw["org_id"];
  versionId: Version["id"];
}): Promise<void> => {
  const { apiOrganizationIdParams } = getAPIConfigs(organizationId);
  await API_CLIENT.post(
    `${apiUrl}/${versionId}/remove`,
    {},
    {
      ...apiOrganizationIdParams,
    }
  );
};

// 評価、最適化の処理をキャンセル
export const postCancelVersion = async ({
  organizationId,
  versionId,
}: {
  organizationId: OrganizationRaw["org_id"];
  versionId: Version["id"];
}): Promise<void> => {
  const { apiOrganizationIdParams } = getAPIConfigs(organizationId);
  await API_CLIENT.post(
    `${apiUrl}/${versionId}/stop_optimization_job`,
    {},
    {
      ...apiOrganizationIdParams,
    }
  );
};
